import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/sections/Hero";
import { SyaratAsas } from "@/components/sections/SyaratAsas";
import { ProsesMudah } from "@/components/sections/ProsesMudah";
import { KenapaPilih } from "@/components/sections/KenapaPilih";
import { CtaBlock } from "@/components/sections/CtaBlock";
import { Faq } from "@/components/sections/Faq";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

const LandingPage = () => (
  <div data-testid="landing-page" className="min-h-screen bg-white font-body">
    <Navbar />
    <main>
      <Hero />
      <SyaratAsas />
      <ProsesMudah />
      <KenapaPilih />
      <CtaBlock />
      <Faq />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

export default LandingPage;
